<script lang="ts">
  import { cn } from '../lib/cn';

  const sizes = {
    sm: 'size-8 rounded-md text-sm',
    md: 'size-9 rounded-md text-base',
    lg: 'size-14 rounded-lg text-2xl',
  } as const;

  /**
   * The brand's signature element: a flat ink tile carrying the first letter of an organization's name.
   * Purely decorative (the name is always rendered next to it), so it is hidden from assistive tech.
   */
  let { name, size = 'md', class: className }: { name: string; size?: keyof typeof sizes; class?: string } = $props();
  const letter = $derived(Array.from(name.trim())[0] ?? '·');
</script>

<span aria-hidden="true" class={cn('inline-grid shrink-0 place-items-center bg-accent-soft font-bold text-tone-ink', sizes[size], className)}
  >{letter}</span
>
